// fontawesome
import {
  IconDefinition,
  IconName,
  library,
} from '@fortawesome/fontawesome-svg-core';

// icons - find icons at https://fontawesome.com/search
import {
  faArrowCircleDown,
  faArrowCircleUp,
  faArrowDownToBracket,
  faArrowRightFromBracket,
  faArrowsRotate,
  faBadgeCheck,
  faBell,
  faBook,
  faBookHeart,
  faBookmark,
  faBookOpen,
  faBox,
  faBuilding,
  faBus,
  faCalendar,
  faCalendarCheck,
  faCamera,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faEllipsisVertical,
  faChevronsDown,
  faChevronsLeft,
  faChevronsRight,
  faChevronsUp,
  faChevronUp,
  faCircle,
  faCircleHeart,
  faCirclePlus,
  faCircleQuestion,
  faCircleSterling,
  faClipboard,
  faClipboardCheck,
  faClipboardList,
  faClock,
  faCouch,
  faCopy,
  faDiscDrive,
  faDownload,
  faEdit,
  faEnvelope,
  faEnvelopeOpenText,
  faEnvelopes,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faFileContract,
  faFileLines,
  faFilePlus,
  faFlag,
  faFolderOpen,
  faGear,
  faHandHolding,
  faHandHoldingHeart,
  faHandsHoldingHeart,
  faHeadset,
  faHeart,
  faHeartPulse,
  faHome,
  faHorizontalRule,
  faHouse,
  faHouseBlank,
  faInfoCircle,
  faKitMedical,
  faLink,
  faLinkSlash,
  faList,
  faListCheck,
  faLocationArrow,
  faLocationDot,
  faLongArrowLeft,
  faLongArrowRight,
  faMagnifyingGlass,
  faMagnifyingGlassLocation,
  faMailbox,
  faMapMarkerAlt,
  faMemo,
  faMessage,
  faMinus,
  faMoneyBills,
  faMoneyCheckPen,
  faPaperPlaneTop,
  faPartyHorn,
  faPen,
  faPencil,
  faPenField,
  faPersonWalking,
  faPhone,
  faPhonePlus,
  faPlay,
  faPlus,
  faPlusSquare,
  faPrint,
  faQuestionCircle,
  faRotateRight,
  faRoute,
  faScaleBalanced,
  faSearch,
  faShieldHalved,
  faSitemap,
  faSmile,
  faSpa,
  faSparkles,
  faStar,
  faSterlingSign,
  faTimes,
  faTrash,
  faTruckFast,
  faTv,
  faUpload,
  faUser,
  faUserGroup,
  faUserNurse,
  faUserHeadset,
  faUsers,
  faVideo,
  faXmark,
  faCheckSquare,
  faDotCircle,
  faSquare,
  faBed,
  faHotel,
  faImages,
  faPoundSign,
  faShieldAlt,
  faShieldCheck,
  faShieldPlus,
  faSlidersH,
  faToilet,
  faKeySkeleton,
  faHouseHeart,
  faUserPlus,
  faWheelchair,
  faMicrophone,
  faStop,
  faPause,
  faPaperclip,
} from '@fortawesome/pro-light-svg-icons';

import {
  faBookmark as faBookmarkSolid,
  faCalendar as faCalendarSolid,
  faCheck as faCheckSolid,
  faCheckCircle as faCheckCircleSolid,
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faCircle as faCircleSolid,
  faCircleXmark as faCircleXmarkSolid,
  faHandHoldingHeart as faHandHoldingHeartSolid,
  faHouseBlank as faHouseBlankSolid,
  faListCheck as faListCheckSolid,
  faMagnifyingGlass as faMagnifyingGlassSolid,
  faMagnifyingGlassLocation as faMagnifyingGlassLocationSolid,
  faMessage as faMessageSolid,
  faMicrophone as faMicrophoneSolid,
  faPaperPlaneTop as faPaperPlaneTopSolid,
  faRotateRight as faRotateRightSolid,
  faSparkles as faSparklesSolid,
  faStar as faStarSolid,
  faStop as faStopSolid,
  faXmark as faXmarkSolid,
  faGear as faGearSolid,
  faHeart as faHeartSolid,
  faHouse as faHouseSolid,
  faCouch as faCouchSolid,
  faPen as faPenSolid,
  faHandsHelping as faHandsHelpingSolid,
  faQuoteLeft as faQuoteLeftSolid,
  faQuoteRight as faQuoteRightSolid,
  faUserNurse as faUserNurseSolid,
  faMapMarker as faMapMarkerSolid, // TODO: fix
  faKeySkeleton as faKeySkeletonSolid,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faApple,
  faFacebook,
  faGoogle,
  faLinkedin,
  faMicrosoft,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

type IconTypeKey = 'faIcons' | 'faIconsSolid' | 'faIconsBrands';

type IconSet = {
  [key in IconName]?: IconDefinition;
};

type IconType = {
  [key in IconTypeKey]: IconSet;
};

export const iconTypes: IconType = {
  faIcons: {
    'exclamation-triangle': faExclamationTriangle,
    'arrow-circle-down': faArrowCircleDown,
    'arrow-circle-up': faArrowCircleUp,
    'arrow-down-to-bracket': faArrowDownToBracket,
    'arrows-rotate': faArrowsRotate,
    'badge-check': faBadgeCheck,
    'check-square': faCheckSquare,
    'dot-circle': faDotCircle,
    square: faSquare,
    bed: faBed,
    hotel: faHotel,
    images: faImages,
    'pound-sign': faPoundSign,
    'shield-alt': faShieldAlt,
    'shield-plus': faShieldPlus,
    'sliders-h': faSlidersH,
    'ellipsis-vertical': faEllipsisVertical,
    toilet: faToilet,
    bell: faBell,
    book: faBook,
    bookmark: faBookmark,
    'book-open': faBookOpen,
    box: faBox,
    building: faBuilding,
    bus: faBus,
    'circle-sterling': faCircleSterling,
    check: faCheck,
    circle: faCircle,
    'check-circle': faCheckCircle,
    'chevron-down': faChevronDown,
    'chevron-left': faChevronLeft,
    'chevron-right': faChevronRight,
    'chevron-up': faChevronUp,
    'chevrons-down': faChevronsDown,
    'chevrons-left': faChevronsLeft,
    'chevrons-right': faChevronsRight,
    'chevrons-up': faChevronsUp,
    clipboard: faClipboard,
    'clipboard-check': faClipboardCheck,
    'clipboard-list': faClipboardList,
    'circle-heart': faCircleHeart,
    'circle-plus': faCirclePlus,
    'circle-question': faCircleQuestion,
    couch: faCouch,
    copy: faCopy,
    'disc-drive': faDiscDrive,
    download: faDownload,
    edit: faEdit,
    eye: faEye,
    'book-heart': faBookHeart,
    'file-contract': faFileContract,
    'file-lines': faFileLines,
    'file-plus': faFilePlus,
    flag: faFlag,
    gear: faGear,
    'hand-holding': faHandHolding,
    'hand-holding-heart': faHandHoldingHeart,
    'hands-holding-heart': faHandsHoldingHeart,
    headset: faHeadset,
    heart: faHeart,
    'heart-pulse': faHeartPulse,
    home: faHome,
    house: faHouse,
    'house-blank': faHouseBlank,
    'house-heart': faHouseHeart,
    'info-circle': faInfoCircle,
    'key-skeleton': faKeySkeleton,
    'kit-medical': faKitMedical,
    list: faList,
    'list-check': faListCheck,
    link: faLink,
    'link-slash': faLinkSlash,
    'location-arrow': faLocationArrow,
    'long-arrow-left': faLongArrowLeft,
    'long-arrow-right': faLongArrowRight,
    'arrow-right-from-bracket': faArrowRightFromBracket,
    'map-marker-alt': faMapMarkerAlt,
    'magnifying-glass': faMagnifyingGlass,
    'magnifying-glass-location': faMagnifyingGlassLocation,
    memo: faMemo,
    minus: faMinus,
    'money-bills': faMoneyBills,
    message: faMessage,
    'paper-plane-top': faPaperPlaneTop,
    'party-horn': faPartyHorn,
    'person-walking': faPersonWalking,
    phone: faPhone,
    'phone-plus': faPhonePlus,
    play: faPlay,
    plus: faPlus,
    'plus-square': faPlusSquare,
    print: faPrint,
    'rotate-right': faRotateRight,
    route: faRoute,
    'scale-balanced': faScaleBalanced,
    search: faSearch,
    'shield-check': faShieldCheck,
    'shield-halved': faShieldHalved,
    sitemap: faSitemap,
    smile: faSmile,
    spa: faSpa,
    sparkles: faSparkles,
    star: faStar,
    'sterling-sign': faSterlingSign,
    times: faTimes,
    trash: faTrash,
    tv: faTv,
    upload: faUpload,
    user: faUser,
    'user-nurse': faUserNurse,
    users: faUsers,
    'user-headset': faUserHeadset,
    xmark: faXmark,
    'exclamation-circle': faExclamationCircle,
    'question-circle': faQuestionCircle,
    mailbox: faMailbox,
    envelope: faEnvelope,
    envelopes: faEnvelopes,
    'envelope-open-text': faEnvelopeOpenText,
    pen: faPen,
    pencil: faPencil,
    'pen-field': faPenField,
    'truck-fast': faTruckFast,
    'money-check-pen': faMoneyCheckPen,
    'folder-open': faFolderOpen,
    calendar: faCalendar,
    camera: faCamera,
    'calendar-check': faCalendarCheck,
    'horizontal-rule': faHorizontalRule,
    clock: faClock,
    'location-dot': faLocationDot,
    video: faVideo,
    'user-group': faUserGroup,
    'user-plus': faUserPlus,
    wheelchair: faWheelchair,
    microphone: faMicrophone,
    stop: faStop,
    pause: faPause,
    paperclip: faPaperclip,
  },
  faIconsSolid: {
    bookmark: faBookmarkSolid,
    calendar: faCalendarSolid,
    check: faCheckSolid,
    circle: faCircleSolid,
    couch: faCouchSolid,
    'hands-helping': faHandsHelpingSolid,
    'quote-left': faQuoteLeftSolid,
    'quote-right': faQuoteRightSolid,
    'user-nurse': faUserNurseSolid,
    'check-circle': faCheckCircleSolid,
    'circle-xmark': faCircleXmarkSolid,
    'chevron-left': faChevronLeftSolid,
    'chevron-right': faChevronRightSolid,
    'paper-plane-top': faPaperPlaneTopSolid,
    'rotate-right': faRotateRightSolid,
    'map-marker': faMapMarkerSolid,
    pen: faPenSolid,
    xmark: faXmarkSolid,
    'house-blank': faHouseBlankSolid,
    'list-check': faListCheckSolid,
    'hand-holding-heart': faHandHoldingHeartSolid,
    gear: faGearSolid,
    heart: faHeartSolid,
    house: faHouseSolid,
    'magnifying-glass': faMagnifyingGlassSolid,
    'magnifying-glass-location': faMagnifyingGlassLocationSolid,
    message: faMessageSolid,
    sparkles: faSparklesSolid,
    star: faStarSolid,
    'key-skeleton': faKeySkeletonSolid,
    microphone: faMicrophoneSolid,
    stop: faStopSolid,
  },
  faIconsBrands: {
    apple: faApple,
    facebook: faFacebook,
    linkedin: faLinkedin,
    'x-twitter': faXTwitter,
    google: faGoogle,
    microsoft: faMicrosoft,
  },
};

// Extracting icon names from all sets
type IconNames<T extends IconType> = {
  [K in keyof T]: keyof T[K];
}[keyof T];

// Define the Icons type by inferring names from the iconTypes structure
export type Icons = IconNames<typeof iconTypes>;

// retrieve a list of all libraries
const iconLibraries = Object.keys(iconTypes).map((iconTypeKey) => {
  return iconTypes[iconTypeKey as keyof IconType];
});

// add to library and export types
iconLibraries.forEach((iconLibrary) => {
  library.add(...Object.values(iconLibrary));
});

/**
 * validateIcon ensures the provided icon string is of type Icons, and returns
 * the 'star' icon as a default if it is not.
 */
export const validateIcon = (icon: string): Icons => {
  let isIcon = false;
  iconLibraries.forEach((iconLibrary) => {
    if (icon in iconLibrary) {
      isIcon = true;
    }
  });

  if (!isIcon) return 'star';

  return icon as Icons;
};
